import { STATUS_META } from "@/lib/status";
import { useI18n } from "@/context/I18nContext";

export default function StatusBadge({ status, size = "md", hideUnknown = false }) {
  const { t } = useI18n();
  const meta = STATUS_META[status] || STATUS_META.UNKNOWN;
  if (hideUnknown && status === "UNKNOWN") return null;
  const padding =
    size === "lg" ? "px-4 py-2 text-sm" : size === "sm" ? "px-2 py-1 text-xs" : "px-3 py-1.5 text-xs";
  // Soften the "unknown" messaging so public visitors never see raw placeholder text
  const label =
    status === "UNKNOWN"
      ? t("status.unverified", "Status pending verification")
      : t(`status.${status}`, meta.label);
  return (
    <span
      data-testid="facility-status-badge"
      className={`inline-flex items-center gap-2 rounded-full font-semibold uppercase tracking-wide ${padding} ${meta.cls}`}
    >
      <span aria-hidden="true">{meta.icon}</span>
      {label}
    </span>
  );
}
